"use client";

import { queryRenderedSelector } from "@/lib/ui/rendered-elements";

const MODAL_CONTENT_SELECTOR = [
  '[data-slot="dialog-content"][data-state="open"]',
  '[data-slot="drawer-content"][data-state="open"]',
  '[role="dialog"][data-state="open"]',
].join(",");

export function scheduleModalPointerEventsCleanup() {
  if (typeof window === "undefined") return;

  for (const delay of [0, 250, 700]) {
    window.setTimeout(() => {
      // Must be a *rendered* modal. A route left behind with a dialog open stays
      // in the document inside a hidden Activity boundary, still tagged
      // data-state="open" — and <body> is outside that boundary, so matching it
      // here would leave pointer-events: none pinned on the whole app forever.
      if (queryRenderedSelector(MODAL_CONTENT_SELECTOR)) return;
      if (document.body.style.pointerEvents === "none") {
        document.body.style.pointerEvents = "";
      }
    }, delay);
  }
}
